function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWeight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 800,
    height: 800,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M469.332.004H42.668C19.101.004 0 19.104 0 42.673v426.655c0 23.567 19.101 42.668 42.668 42.668h426.664c23.567 0 42.668-19.101 42.668-42.668V42.673C512 19.104 492.899.004 469.332.004M364.37 191.877h-65.293l11.409-68.16-10.592-2.15-10.6-2.167-17.443 72.477H147.63l-28.151-81.902c39.867-24.026 86.578-37.868 136.529-37.868 49.943 0 96.645 13.842 136.513 37.868z",
    style: {
      fill: "white"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeight);
export default __webpack_public_path__ + "static/media/weight.306fffaf4092b564650ff1f1faba842d.svg";
export { ForwardRef as ReactComponent };